<template>
  <div class="pagination-listing">
    <div class="pagination-listing__wrap">
      <NuxtLink
        v-if="page > 1"
        :to="{
          query: {
            page: page - 1,
          },
        }"
        class="pagination-listing__button --prev"
        :class="{
          '--disabled': page <= 1,
        }"
        :aria-disabled="page <= 1"
        aria-label="Previous"
      ></NuxtLink>
      <div class="pagination-listing__pages text-m">
        {{ page }} / {{ pages }}
      </div>
      <NuxtLink
        :to="{
          query: {
            page: page + 1,
          },
        }"
        v-if="page < pages"
        class="pagination-listing__button --next"
        :class="{
          '--disabled': page >= pages,
        }"
        :aria-disabled="page >= pages"
        aria-label="Next"
      ></NuxtLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetPaginationListing',
}
</script>

<script setup>
const props = defineProps({
  itemPerPage: Number,
  total: Number,
})

const lenis = inject('lenis')

const route = useRoute()
// const router = useRouter()

const pages = computed(() => Math.ceil(props.total / props.itemPerPage))
const page = ref(route.query?.page ? parseInt(route.query.page) : 1)

/* const updatePage = (page) => {
  router.push({
    query: {
      page,
    },
  })
} */

watch(
  () => route.query.page,
  (newPage) => {
    if (newPage) {
      page.value = parseInt(newPage)
      lenis.value.scrollTo(0)
    }
  }
)
</script>

<style lang="scss">
@import './style.scss';
</style>
